"use client";
import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";

export default function IndustryTestimonial({ data = {} }) {
  if (!data?.testimonial) return null;

  const { quote, author, role, avatar, companyLogo } = data.testimonial;

  const hasAvatar = typeof avatar === "string" && avatar.trim() !== "";
  const hasLogo = typeof companyLogo === "string" && companyLogo.trim() !== "";

  return (
    <section className="py-24 px-6 sm:px-12 lg:px-24">
      <div className="container mx-auto">
        <motion.div 
          className="bg-white/5 rounded-[1rem] p-10 md:p-16 relative shadow-sm overflow-visible"
        >
          <div className="absolute -top-8 left-10 w-16 h-16 flex items-center justify-center">
            <Image src="/odoo/snippets/s_wd_testimonials/quote.svg" width={64} height={64} className="w-full h-full object-contain" alt="" />
          </div>

          <div className="grid lg:grid-cols-12 gap-12 items-center relative z-10">
            <div className="lg:col-span-8">
              <blockquote className="text-xl md:text-2xl font-medium leading-relaxed text-gray-100">
                "{quote}"
              </blockquote>
            </div>
            
            <div className="lg:col-span-4 flex flex-col items-center lg:items-end text-center lg:text-right">
              {hasAvatar ? (
                <div className="mb-6">
                  <Image 
                    src={avatar} 
                    width={96}
                    height={96}
                    className="w-24 h-24 rounded-full border-4 border-white shadow-md object-cover" 
                    alt={author || "Avatar"} 
                  />
                </div>
              ) : null}
              <div className="mb-6">
                <b className="text-xl block text-white font-bold">{author}</b>
                <small className="text-gray-400 text-sm block mt-1">{role}</small>
              </div>
              {hasLogo ? (
                <div className="bg-white/5 p-3 rounded-lg shadow-sm border border-white/10 inline-block">
                  <Image src={companyLogo} width={120} height={32} className="h-8 w-auto object-contain" alt="Company Logo" />
                </div>
              ) : null}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
